module.exports = __webpack_public_path__ + "static/media/four.12358c90.png";